import { maxBy, minBy } from "lodash"

export const getMinMaxData = (chartsData, chart, index, axis) => {
    return [
        minBy(chartsData[chart].dataArray[index].data, value => value[axis])[axis],
        maxBy(chartsData[chart].dataArray[index].data, value => value[axis])[axis],
    ]
}